export default class Area {

    constructor(sistema='', codigo='', nome='', icone='', ordem=0, contexto='', areaSuperior='') {
        this.sistema = sistema
        this.codigo = codigo
        this.nome = nome
        this.icone = icone
        this.orgem = ordem
        this.contexto = contexto
        this.areaSuperior = areaSuperior
    }

    static buildFromJson(json={}){
        return new Area(
            json.nomsis,
            json.codarengcpoa,
            json.nomarengcpoa,
            json.codicoapt,
            json.ordaptarengc,
            json.ctxsispgn,
            json.codarengcspe
        )
    }
}